import apinode from '../../apinode'

class WmsInventarioOSService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll({ inventoryId }) {
    const response = await apinode.get(
      `/wms-inventario-os/${this.idconta}?inventoryId=${inventoryId}`,
    )

    return response.data
  }

  async assignAccountant(id, { contador }) {
    await apinode.patch(`/wms-inventario-os/${id}/${this.idconta}`, {
      contador,
    })
  }
}

export default new WmsInventarioOSService()
